import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { each, map } from 'lodash';
import { t } from 'i18next';
import { Icomoon } from '../Icomoon';
import { Link } from 'react-router-dom';

const propTypes = {
	kind: PropTypes.oneOf(['count', 'badge', 'full']),
	counts: PropTypes.object,
	onClearUnread: PropTypes.func,
};

const defaultProps = {
	kind: 'count',
	counts: {},
	onClearUnread: () => void 0,
};

const Notifications = ({ className, kind, counts, onClearUnread, ...other }) => {
	const wrapperClasses = classNames(
		'tbk--notifications',
		{
			'tbk--notifications--count' : kind === 'count',
			'tbk--notifications--badge' : kind === 'badge',
			'tbk--notifications--full' : kind === 'full',
		},
		className
	);

	let pages = {
		news: {
			pageName: t('News Feed'),
			postTypes: ['news','post'],
			linkTo: '/news/new',
			count: 0,
		}
	};
	let allPostTypes = [];
	each( pages, page => {
		page.postTypes.forEach( postType => {
			page.count += counts[ postType ] || 0;
			if ( allPostTypes.indexOf( postType ) === -1 ) {
				allPostTypes.push( postType );
			}
		});
	});
	let totalCount = 0;
	each( pages, page => { totalCount += page.count; } );

	if (kind === 'count') {
		return totalCount;
	}

	if (kind === 'badge') {
		return (
			<div className={wrapperClasses} {...other}>
				<Icomoon icon="alert"/>
				{totalCount > 0 &&
				<div className="tbk--notifications--badge__number">{totalCount}</div>
				}
			</div>
		);
	}

	if (kind === 'full') {

		const heading = <div className="tbk--notifications__heading">
			<div className="tbk--notifications__heading-title">{t('Notifications')}</div>
			{totalCount
				? <button className="bx--link" onClick={() => onClearUnread(allPostTypes)} type="button">{t('Mark All as Read')}</button>
				: ''
			}
		</div>;

		return (
			<div className={wrapperClasses} {...other}>
				{heading}
				<ul className="tbk--notifications__list">
					{totalCount
						? map( pages, ( page, key ) => {
							const sprintf = [
								page.count,
								page.count === 1 ? t('item') : t('items'),
								page.pageName
							];
							return page.count
								? <li className="tbk--notifications__item tbk--notifications__item--unread" key={key}>
									<Link className="tbk--notifications__item__link" to={page.linkTo}>
										<div className="tbk--notifications__title">
											{t('You have %s unread %s on your %s',{postProcess: 'sprintf', sprintf})}
										</div>
									</Link>

									<div className="tbk--notifications__clear">
										<span className="tbk--tags">
											<a className="tbk--tags__click" onClick={() => onClearUnread(page.postTypes)} role="button">{t('Clear')} <span className="sr-only">{t('notifications')}</span>
											</a>
										</span>
									</div>
								</li>
								: null
						})
						: <li className="tbk--notifications__empty">{t('You have no unread notifications') + '.'}</li>
					}
				</ul>
			</div>
		);
	}
};


Notifications.propTypes = propTypes;
Notifications.defaultProps = defaultProps;

export { Notifications };



// WEBPACK FOOTER //
// ./src/components/Notifications/Notifications.js